import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import { num, pct, share } from "./format";

// key = employee table tab the segment filters to
const SEGMENTS = [
  { key: "punched_in", tab: "punched_in", label: "Punched In", color: "#1f9d55" },
  { key: "not_punched_in", tab: "not_punched_in", label: "Not Punched In", color: "#8a8a9e" },
  { key: "leave", tab: "leave", label: "On Leave", color: "#e0a106" },
  { key: "weekoff", tab: "weekoff", label: "Week Off", color: "#c9c9d6" },
];

const PunchDonut = ({ data, loading, activeTab, onPick }) => {
  const total = data?.total || 0;
  const rostered = total - (data?.leave || 0) - (data?.weekoff || 0);
  const slices = SEGMENTS.map((s) => ({ ...s, value: data?.[s.key] || 0 })).filter((s) => s.value > 0);

  return (
    <div className={`a2-card ${loading ? "a2-loading" : ""}`}>
      <div className="a2-card-head">
        <div>
          <h3 className="a2-card-title">Punch-In Status</h3>
          <div className="a2-card-sub">Select a segment to filter the employee table</div>
        </div>
      </div>
      <div className="a2-donut-wrap">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={slices.length ? slices : [{ key: "none", value: 1, color: "#eeeef4" }]}
              dataKey="value"
              innerRadius={68}
              outerRadius={92}
              paddingAngle={slices.length > 1 ? 1 : 0}
              startAngle={90}
              endAngle={-270}
              stroke="none"
              onClick={(s) => s?.tab && onPick(s.tab)}
            >
              {(slices.length ? slices : [{ key: "none", color: "#eeeef4" }]).map((s) => (
                <Cell key={s.key} fill={s.color} style={{ cursor: s.tab ? "pointer" : "default" }} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="a2-donut-center">
          <div>
            <b>{pct(share(data?.punched_in || 0, rostered))}</b>
            <small>of rostered<br />punched in</small>
          </div>
        </div>
      </div>
      <div className="a2-seglist">
        {SEGMENTS.map((s) => (
          <button key={s.key} className={activeTab === s.tab ? "active" : ""} onClick={() => onPick(s.tab)}>
            <i style={{ background: s.color }} />
            <span>{s.label}</span>
            <b>{num(data?.[s.key] || 0)}</b>
            <em>{pct(share(data?.[s.key] || 0, total))}</em>
          </button>
        ))}
      </div>
      <div className="a2-tiles">
        <div className="a2-tile bg-blue">
          <b>{num(data?.punched_in)}</b>
          <small>Punched In</small>
        </div>
        <div className="a2-tile bg-grey">
          <b>{num(data?.not_punched_in)}</b>
          <small>Not Punched In</small>
        </div>
      </div>
    </div>
  );
};

export default PunchDonut;
